import useApi from '../../../services/useApi'
import useFilters from '../../../hook/useFilters'
import {useState} from 'react'

export const useGetProductReport = () => {
  const Api = useApi()
  const [isFetchingCsvData, setIsFetchingCsvData] = useState(false)

  const initialFilters = {
    page: 1,
    limit: 30,
    searchValue: '',
    days_to_replenishment: '180',
    purchaser: '',
    sort_by: 'product_title/1',
    hide_discontinued: true,
  }

  const {filters, onPageChange, setSingleFilter, onSortingChange} = useFilters(initialFilters, {
    sortType: 'number',
  })

  const {data: response, isFetching} = Api.useGetQuery('/purchaser/analytics/no-sold/data', {
    queryId: 'no-sold-product-report',
    filters,
  })

  const onDaysChange = (value: string) => {
    setSingleFilter('days_to_replenishment', value)
  }

  const onPurchaserChange = (value: string) => {
    setSingleFilter('purchaser', value)
  }

  const onSearch = (value: string) => {
    setSingleFilter('searchValue', value)
    setSingleFilter('page', 1)
  }

  const onHideDiscontinuedChange = (value: boolean) => {
    setSingleFilter('hide_discontinued', value)
  }

  const onDownloadCsv = () => {
    return Api.get('/purchaser/analytics/no-sold/csvdata', {
      setLoading: setIsFetchingCsvData,
      filters: filters,
    })
  }

  return {
    reportData: response?.data || [],
    isLoading: isFetching,
    filters,
    onSearch,
    onDaysChange,
    onPurchaserChange,
    onHideDiscontinuedChange,
    pagination: response?.meta?.pagination || {},
    onPageChange,
    onSortingChange,
    onDownloadCsv,
    isFetchingCsvData,
  }
}
